import React from "react";
import AdminRequestsImportComp from "../../components/Admin/AdminRequestsImport";

export default function AdminRequestsImportPage() {
  return <AdminRequestsImportComp />;
}